import { PrimaryButton } from '@/components/buttons/PrimaryButton';
import { SecondaryButton } from '@/components/buttons/SecondaryButton';
import { Dialog, DialogContent, DialogHeader, DialogPortal, DialogTitle } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import ErrorCircleIcon from '../icons/ErrorCircleIcon';

interface Props {
    open: boolean;
    onClickButton1: () => void;
    onClickButton2: () => void;
    text1: string;
    text2: string;
    textButton1: string;
    textButton2: string;
}

const CancelPopup = ({ open, onClickButton1, onClickButton2, text1, text2, textButton1, textButton2 }: Props) => {
    return (
        <Dialog open={open}>
            <DialogPortal>
                <div
                    className={cn('fixed inset-0 bg-black/50 z-[999] p-3', {
                        '!hidden': !open,
                    })}
                />
            </DialogPortal>
            <DialogContent
                showCloseButton={false}
                className="z-[1000] max-w-lg rounded-lg p-6 bg-white-blue-50 font-cairo gap-0 [&_[aria-label=Close]]:opacity-0"
            >
                <DialogHeader className="flex flex-col items-center">
                    <ErrorCircleIcon className="text-red-error-600 text-center mb-[10px]" />
                    <DialogTitle className="text-center text-red-error-600 font-bold sm:text-[22px] text-[18px] leading-[33px] tracking-normal">
                        {text1}
                    </DialogTitle>
                </DialogHeader>

                <div className="mt-2 mb-6 text-center text-[#6B7280] font-medium sm:text-[14px] text-[12px] leading-[28px] tracking-normal">
                    <p>{text2}</p>
                </div>

                <div className="flex flex-col min-[400px]:flex-row gap-3">
                    <PrimaryButton
                        onClick={onClickButton1}
                        className="w-full sm:text-base text-[14px] leading-5 tracking-normal font-medium py-[10px]"
                    >
                        {textButton1}
                    </PrimaryButton>
                    <SecondaryButton
                        onClick={onClickButton2}
                        className="w-full sm:text-base text-[14px] leading-5 tracking-normal bg-red-error-50 text-red-error-600 py-[10px] font-medium"
                    >
                        {textButton2}
                    </SecondaryButton>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default CancelPopup;
